import { VueSlideToggle } from "vue-slide-toggle";

export default {
  name: 'ReviewsSelect',
  data() {
    return {
      open: false,
      selectedText: '',
      selectedValues: [],
    }
  },
  components: {
    VueSlideToggle
  },
  props: {
    placeholder: {
      type: String,
      default: "Choose item"
    },
    list: {
      type: Object,
      default: () => ({})
    }
  },
  created() {
    this.$nextTick(() => {
      this.selectedText = this.placeholder
    })
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('clear-selects', this.clearSelect)
      document.addEventListener('click', this.handleClickOutside)
    })
  },
  beforeDestroy() {
    this.open = false
    window.removeEventListener('clear-selects', this.clearSelect)
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleOpenClick() {
      this.open = !this.open
      if (this.open) {
        this.$refs.input.focus();
      }
    },
    handleClickOutside(event) {
      // Close the select if click is outside the component
      if (this.open && this.$el && !this.$el.contains(event.target)) {
        this.open = false
      }
    },
    handleCloseSelects() {
      setTimeout(() => {
        this.open = false
      }, 100)
    },
    clearSelect() {
      this.selectedText = this.placeholder
      this.selectedValues = []
      this.open = false
    },
    handleSelect(value) {
      const index = this.selectedValues.findIndex(v => v.id === value.id)
      if (index > -1) {
        this.selectedValues.splice(index, 1)
      } else {
        this.selectedValues.push(value)
      }
      this.updateSelectedText()
      this.$emit('select', this.selectedValues)
    },
    isSelected(value) {
      return this.selectedValues.some(v => v.id === value.id)
    },
    updateSelectedText() {
      if (this.selectedValues.length === 0) {
        this.selectedText = this.placeholder
      } else if (this.selectedValues.length === 1) {
        this.selectedText = this.selectedValues[0].title
      } else {
        this.selectedText = `${this.selectedValues.map(item => item.title).join(', ')}`
      }
    }
  }
}
